import { render, staticRenderFns } from "./table-loading.vue?vue&type=template&id=1ca8b80e&scoped=true&"
import script from "./table-loading.vue?vue&type=script&lang=js&"
export * from "./table-loading.vue?vue&type=script&lang=js&"
import style0 from "./table-loading.vue?vue&type=style&index=0&id=1ca8b80e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8b80e",
  null
  
)

export default component.exports